// @flow

import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { log } from '../../utils/jsUtils';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import StyledPhoneInput from '../SharedComponents/StyledPhoneInput';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import Input from '@mui/material/Input';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { createClasses } from '../../utils/stylesUtils';
import addStaffDialogStyles from './Styles/AddStaffDialog.Style';

type Props = {
  setOpen: Function,
  open: boolean,
  triggerAction: Function
};

// eslint-disable-next-line react/no-multi-comp
const AddStaff = (props: Props) => {
  const { setOpen, open, triggerAction } = props;
  const theme = useTheme();
  const classes = createClasses(addStaffDialogStyles, theme);
  const [isLoading, setIsLoading] = useState(false);
  const { register, unregister, handleSubmit, errors, clearErrors, watch, setValue } = useForm({
    FirstName: '',
    LastName: '',
    Phone: '',
    Email: '',
    inviteChannel: 'sms',
    IsAdmin: false,
    IsManager: false,
    IsOwner: false
  }); // initialise the hook
  const inviteChannels = watch('InviteChannel', 'sms');
  const phone = watch('phone', '');
  log('InviteChannel, errors: ', inviteChannels, errors);

  useEffect(() => {
    register({
      name: 'InviteChannel',
      value: 'sms'
    }, { required: true });
    
    return () => unregister('InviteChannel'); // unregister input after component unmount
  }, [register]);

  useEffect(() => {
    log('[useEffect] inviteChannels, errors: ', inviteChannels, errors);
    if (inviteChannels === 'email') {
      clearErrors('phone');
      register({ name: 'Email' }, { required: true });
      register({ name: 'Phone' }, { required: false });
    } else {
      clearErrors('email');
      register({ name: 'Email' }, { required: false });
      register({ name: 'Phone' }, { required: true });
    }

    log('[useEffect] inviteChannels, errors: ', inviteChannels);
  }, [inviteChannels]);

  return (
    <Dialog
      aria-labelledby='form-staff'
      onClose={() => setOpen(false)}
      open={open}
    >
      <Box
        component='form'
        autoComplete='off'
        sx={classes.dialogFormCtr}
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(
            triggerAction(
              () => setIsLoading(true),
              () => setIsLoading(false),
              () => setIsLoading(false)
            )
          )(e);
        }}
        // e => {
        //   e.preventDefault();
        //   if (triggerAction(staff)) {
        //     setOpen(false);
        //   }
        // }}
      >
        <DialogTitle id='form-dialog-title'>{'Invite new staff member'}</DialogTitle>
        <DialogContent sx={{ ...classes.grow, ...classes.flexContainer }}>
          <Box id='createStaff'>
            <Input
              autoFocus
              sx={classes.secondInput}
              fullWidth
              id='firstName'
              inputRef={register({ required: true })}
              placeholder='First Name'
              name='FirstName'
              type='text'
            />
            <Box sx={classes.error}>{ errors.FirstName && 'First name is required.' }</Box>
            <Input
              sx={classes.secondInput}
              fullWidth
              id='lastName'
              inputRef={register({ required: true })}
              placeholder='Last Name'
              name='LastName'
              type='text'
            />
            <Box sx={classes.error}>{ errors.LastName && 'Last name is required.' }</Box>
            <Box sx={classes.selectLabel}>Send invite by:</Box>
            <Grid
              sx={classes.channelFormControlCtr}
              container
              direction='row'
            >
              <Grid
                item
                xs={4}
              >
                <FormControl variant="standard" sx={classes.formControlSelect}>
                  <Select
                    id="inviteChannel"
                    name='InviteChannel'
                    onChange={(e) => setValue('InviteChannel', e.target.value)}
                    value={inviteChannels}
                    variant="standard"
                    sx={classes.selectStandard}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          borderRadius: 0
                        }
                      }
                    }}
                  >
                    <MenuItem 
                      value='sms'
                    >SMS</MenuItem>
                    <MenuItem 
                      value='email'
                    >Email</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={8}
              >
              {
                inviteChannels === 'email'
                ? <Input
                    fullWidth
                    id='email'
                    placeholder='Email'
                    name='Email'
                    onChange={(e) => setValue('Email', typeof e.target !== 'undefined' ? e.target.value : '')}
                    type='email'
                  />
                : null
              }
              {
                inviteChannels === 'sms'
                ? <StyledPhoneInput
                    defaultCountry='US'
                    onChange={(val) => {
                      log('[phoneInput] val: ', val);
                      clearErrors('Phone');
                      setValue('Phone', val);
                    }}
                    placeholder="Phone"
                    value={formatPhoneNumberIntl(phone)}
                  />
                : null
              }
              <Box sx={classes.error}>{ errors.Phone && 'Phone is required. ' }</Box>
              <Box sx={classes.error}>{ errors.Email && 'Email is required. ' }</Box>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item
xs={12}
              >
                  <FormHelperText>
                    {inviteChannels === 'email' ? 'An' : 'A'}
                    <b>{inviteChannels === 'email' ? ' Email' : ' SMS'}</b>
                    {' invitation to create an account is sent to the new staff member.'}
                  </FormHelperText>
              </Grid>
            </Grid>
            
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            color='primary'
            onClick={() => setOpen(false)}
          >
            {'Cancel'}
          </Button>
          <Button 
            color='primary'
            disabled={isLoading}
            type='submit'
            variant='contained'
          >
            {'Add Staff'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default AddStaff;
